import request from '@/utils/request'
import Vue from 'vue'

//  交易信息
export function getTransactionInformation(data) {
    return request({
        method: 'POST',
        url: Vue.prototype.baseURL + '/product/home-page/getTransactionInformation',
        data
    })
}

// 撮合信息
export function getMatchUpInformation(data) {
    return request({
        method: 'POST',
        url: Vue.prototype.baseURL + '/product/home-page/getMatchUpInformation',
        data
    })
}


// 信息资讯
export function getInformation(data) {
    return request({
        method: 'POST',
        url: Vue.prototype.baseURL + '/product/home-page/getInformation',
        data
    })
}
// 信息资讯 详情
export function informationDetail(params) {
    return request({
        method: 'POST',
        url: Vue.prototype.baseURL + '/product/home-page/informationDetail',
        params
    })
}


// 查询最新的品种价格上报信息
export function getVarietiesNewestData(data) {
    return request({
        method: 'POST',
        url: Vue.prototype.baseURL + '/product/home-page/getVarietiesNewestData',
        data
    })
}



// 专家服务
export function getExpertServices(data) {
    return request({
        method: 'POST',
        url: Vue.prototype.baseURL + '/product/home-page/getExpertServices',
        data
    })
}



//金融保险
export function getFinanceInsurancePage(data) {
    return request({
        method: 'POST',
        url: Vue.prototype.baseURL + '/product/home-page/getFinanceInsurancePage',
        data
    })
}